import { useTranslation } from 'react-i18next';
import { SUPPORT_EMAIL } from '@shared/config/support';

export function AuthSupportFooter() {
  const { t } = useTranslation('auth');

  return (
    <p className="text-center text-sm leading-5 text-muted-foreground px-6 pb-6">
      {t('supportContact.prefix')}{' '}
      <a href={`mailto:${SUPPORT_EMAIL}`} className="underline underline-offset-2">
        {t('supportContact.link')}
      </a>
    </p>
  );
}
